<template>
  <svg
    class="svg-icon"
    aria-hidden="true"
    :style="{ fontSize: `${size}px` }"
  >
    <use :xlink:href="`#${icon}`" />
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
    icon: {
      type: String,
      default: '',
    },
  }
}
</script>
